export default __webpack_public_path__ + "static/media/professional-headshot-website.1ca370f3.jpg";